import addRoute from '@/router/add-route';

const CheckoutPages = () => import('@/modules/checkout-pages/checkout-pages');
const CheckoutPageForm = () => import('@/modules/checkout-pages/checkout-page-form');

const checkoutPages = [
    addRoute({
        name: 'checkout-pages',
        component: CheckoutPages,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'add-checkout-page',
        path: '/checkout-pages/add',
        component: CheckoutPageForm,
        root: {label: 'Settings', name: 'settings'},
    }),
    addRoute({
        name: 'update-checkout-page',
        path: '/checkout-pages/update/:id',
        component: CheckoutPageForm,
        root: {label: 'Settings', name: 'settings'},
    }),
];

export default checkoutPages;
